// The path segments that make something new under /me/documents/index
// (document and index keys are 12 hex characters, so they never collide).

/** /me/documents/index/new: a new index. */
export const NEW_INDEX_KEY = "new";

/** /me/documents/index/<key>/new: a new document in that index. */
export const NEW_DOCUMENT_KEY = "new";
